import React, { useContext, createContext } from 'react';
import PropTypes from 'prop-types';

import useProvideAuth from './_useProvideAuth';

const authContext = createContext();

export const ProvideAuth = ({ children }) => {
  const auth = useProvideAuth();
  return <authContext.Provider value={auth}>{children}</authContext.Provider>;
};

ProvideAuth.propTypes = {
  children: PropTypes.node,
};

export const useAuth = () => {
  return useContext(authContext);
};
